import { resource, RequestConfig } from '../helper/resource';

/**
 * 获取业绩走势
 */
export function getAchTrendUsingPOST(
  req: LcPrivateArchTrendParam | void,
  config?: RequestConfig
): Promise<ApiResultYieldTrendDto> {
  return resource.post('/lcPrivateDetail/getAchTrend', req, config);
}

/**
 * 获取底部固定业绩展示
 */
export function getFixedYieldUsingPOST(
  req: LcPrivateArchTrendParam | void,
  config?: RequestConfig
): Promise<ApiResultFixedPeriodYieldDto> {
  return resource.post('/lcPrivateDetail/getFixedYield', req, config);
}

/**
 * 获取历史净值
 */
export function getHisNavUsingPOST(
  req: LcPrivateDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcPrivateNavVO> {
  return resource.post('/lcPrivateDetail/getHisNav', req, config);
}

/**
 * 获取指数列表
 */
export function getIndexListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListLcIndexDto> {
  return resource.post('/lcPrivateDetail/getIndexList', req, config);
}

/**
 * 获取公告
 */
export function getNoticeUsingPOST(
  req: LcPrivateDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcPrivateNoticeVO> {
  return resource.post('/lcPrivateDetail/getNotice', req, config);
}

/**
 * [No Auth]获取公告-不区分客户
 */
export function getNoticeAllUsingPOST(
  req: LcPrivateDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcPrivateNoticeVO> {
  return resource.postNoAuth('/lcPrivateDetail/getNoticeAll', req, config);
}

/**
 * 获取私募规模走势
 */
export function getPrivateScaleTrendUsingPOST(
  req: LcPrivateArchTrendParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcPrivateScaleVO> {
  return resource.post('/lcPrivateDetail/getPrivateScaleTrend', req, config);
}

/**
 * 获取产品信息
 */
export function getProductUsingPOST(
  req: LcPrivateDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultLcPrivateDetailVO> {
  return resource.post('/lcPrivateDetail/getProduct', req, config);
}

/**
 * getSaleInfo
 */
export function getSaleInfoUsingPOST(
  req: LcPrivateDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListSaleInfoVo> {
  return resource.post('/lcPrivateDetail/getSaleInfo', req, config);
}

/**
 * 获取净值走势
 */
export function getTrendUsingPOST(
  req: LcPrivateDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListNetValueNewDto> {
  return resource.post('/lcPrivateDetail/getTrend', req, config);
}

/**
 * 导入净值数据
 */
export function importNetValueUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListLcIndexDto> {
  return resource.post('/lcPrivateDetail/importNetValue', req, config);
}

/**
 * 导入历史规模数据
 */
export function importScaleValueUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/lcPrivateDetail/importScaleValue', req, config);
}
